import * as tslib_1 from "tslib";
import { NormalBasicMethod } from "./NormalBasicMethod";
/**
 * NormalHeightMapMethod provides a normal map method that uses a height map to calculate the normals.
 */
var NormalHeightMapMethod = (function (_super) {
    tslib_1.__extends(NormalHeightMapMethod, _super);
    /**
     * Creates a new NormalHeightMapMethod method.
     *
     * @param heightMap The texture containing the height data. 0 means low, 1 means high.
     * @param worldWidth The width of the 'world'. This is used to map uv coordinates' u component to scene dimensions.
     * @param worldHeight The height of the 'world'. This is used to map the height map values to scene dimensions.
     * @param worldDepth The depth of the 'world'. This is used to map uv coordinates' v component to scene dimensions.
     */
    function NormalHeightMapMethod(heightMap, worldWidth, worldHeight, worldDepth) {
        var _this = _super.call(this) || this;
        _this.texture = heightMap;
        _this._worldXYRatio = worldWidth / worldHeight;
        _this._worldXZRatio = worldDepth / worldHeight;
        return _this;
    }
    Object.defineProperty(NormalHeightMapMethod.prototype, "assetType", {
        /**
         * @inheritDoc
         */
        get: function () {
            return NormalHeightMapMethod.assetType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NormalHeightMapMethod.prototype, "worldXYRatio", {
        get: function () {
            return this._worldXYRatio;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NormalHeightMapMethod.prototype, "worldXZRatio", {
        get: function () {
            return this._worldXZRatio;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @inheritDoc
     */
    NormalHeightMapMethod.prototype.copyFrom = function (method) {
        _super.prototype.copyFrom.call(this, method);
        this._worldXYRatio = method._worldXYRatio;
        this._worldXZRatio = method._worldXZRatio;
    };
    return NormalHeightMapMethod;
}(NormalBasicMethod));
export { NormalHeightMapMethod };
NormalHeightMapMethod.assetType = "[asset NormalHeightMapMethod]";



// WEBPACK FOOTER //
// ../dist/lib/methods/NormalHeightMapMethod.js